export const USER_LIMIT_REACHED = 'users_limit_reached';

export const LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND';

export const AUTH_PROVIDER_MISMATCH = 'AUTH_PROVIDER_MISMATCH';
